// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__303iA","list_item":"styles_list_item__23Bxa","more":"styles_more__2qUzC"};